import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import statusCodes from '../statusCodes';

var SuccessUrlMissing = /*#__PURE__*/function (_Error) {
  _inherits(SuccessUrlMissing, _Error);

  var _super = _createSuper(SuccessUrlMissing);

  function SuccessUrlMissing() {
    var _this;

    _classCallCheck(this, SuccessUrlMissing);

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.name = 'SuccessUrlMissing';
    _this.message = 'Success url missing to let Stripe know where to redirect users on successful payment.';
    _this.status = statusCodes['Bad Request'];
    return _this;
  }

  return SuccessUrlMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SuccessUrlMustBeString = /*#__PURE__*/function (_Error2) {
  _inherits(SuccessUrlMustBeString, _Error2);

  var _super2 = _createSuper(SuccessUrlMustBeString);

  function SuccessUrlMustBeString() {
    var _this2;

    _classCallCheck(this, SuccessUrlMustBeString);

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'SuccessUrlMustBeString';
    _this2.message = 'Success url must be a string.';
    _this2.status = statusCodes['Bad Request'];
    return _this2;
  }

  return SuccessUrlMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SuccessUrlInvalid = /*#__PURE__*/function (_Error3) {
  _inherits(SuccessUrlInvalid, _Error3);

  var _super3 = _createSuper(SuccessUrlInvalid);

  function SuccessUrlInvalid(invalidProtocol) {
    var _this3;

    _classCallCheck(this, SuccessUrlInvalid);

    for (var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      params[_key3 - 1] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this, invalidProtocol].concat(params));
    _this3.name = 'SuccessUrlInvalid';
    _this3.message = invalidProtocol ? 'Success url must start with http or https.' : 'Success url invalid.';
    _this3.status = statusCodes['Bad Request'];
    return _this3;
  }

  return SuccessUrlInvalid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CancelUrlMissing = /*#__PURE__*/function (_Error4) {
  _inherits(CancelUrlMissing, _Error4);

  var _super4 = _createSuper(CancelUrlMissing);

  function CancelUrlMissing() {
    var _this4;

    _classCallCheck(this, CancelUrlMissing);

    for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      params[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(params));
    _this4.name = 'CancelUrlMissing';
    _this4.message = 'Cancel url missing to let Stripe know where to redirect users on canceled payment.';
    _this4.status = statusCodes['Bad Request'];
    return _this4;
  }

  return CancelUrlMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CancelUrlMustBeString = /*#__PURE__*/function (_Error5) {
  _inherits(CancelUrlMustBeString, _Error5);

  var _super5 = _createSuper(CancelUrlMustBeString);

  function CancelUrlMustBeString() {
    var _this5;

    _classCallCheck(this, CancelUrlMustBeString);

    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(params));
    _this5.name = 'CancelUrlMustBeString';
    _this5.message = 'Cancel url must be a string.';
    _this5.status = statusCodes['Bad Request'];
    return _this5;
  }

  return CancelUrlMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CancelUrlInvalid = /*#__PURE__*/function (_Error6) {
  _inherits(CancelUrlInvalid, _Error6);

  var _super6 = _createSuper(CancelUrlInvalid);

  function CancelUrlInvalid(invalidProtocol) {
    var _this6;

    _classCallCheck(this, CancelUrlInvalid);

    for (var _len6 = arguments.length, params = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      params[_key6 - 1] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this, invalidProtocol].concat(params));
    _this6.name = 'CancelUrlInvalid';
    _this6.message = invalidProtocol ? 'Cancel url must start with http or https.' : 'Cancel url invalid.';
    _this6.status = statusCodes['Bad Request'];
    return _this6;
  }

  return CancelUrlInvalid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var StripeJsLibraryMissing = /*#__PURE__*/function (_Error7) {
  _inherits(StripeJsLibraryMissing, _Error7);

  var _super7 = _createSuper(StripeJsLibraryMissing);

  function StripeJsLibraryMissing() {
    var _this7;

    _classCallCheck(this, StripeJsLibraryMissing);

    for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      params[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(params));
    _this7.name = 'StripeLibraryMissing';
    _this7.message = 'Stripe.js library missing. Be sure to include the script in your html file (https://stripe.com/docs/stripe-js#setup).';
    _this7.status = statusCodes['Bad Request'];
    return _this7;
  }

  return StripeJsLibraryMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PaymentsDisabled = /*#__PURE__*/function (_Error8) {
  _inherits(PaymentsDisabled, _Error8);

  var _super8 = _createSuper(PaymentsDisabled);

  function PaymentsDisabled() {
    var _this8;

    _classCallCheck(this, PaymentsDisabled);

    for (var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      params[_key8] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(params));
    _this8.name = 'PaymentsDisabled';
    _this8.message = 'Payments on this app are disabled. Enable payments in the admin panel.';
    _this8.status = statusCodes['Forbidden'];
    return _this8;
  }

  return PaymentsDisabled;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PriceIdOrPlanIdAllowed = /*#__PURE__*/function (_Error9) {
  _inherits(PriceIdOrPlanIdAllowed, _Error9);

  var _super9 = _createSuper(PriceIdOrPlanIdAllowed);

  function PriceIdOrPlanIdAllowed() {
    var _this9;

    _classCallCheck(this, PriceIdOrPlanIdAllowed);

    for (var _len9 = arguments.length, params = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      params[_key9] = arguments[_key9];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(params));
    _this9.name = 'PriceIdOrPlanIdAllowed';
    _this9.message = 'Only one of priceId or planId allowed.';
    _this9.status = statusCodes['Bad Request'];
    return _this9;
  }

  return PriceIdOrPlanIdAllowed;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PriceIdOrPlanIdMissing = /*#__PURE__*/function (_Error10) {
  _inherits(PriceIdOrPlanIdMissing, _Error10);

  var _super10 = _createSuper(PriceIdOrPlanIdMissing);

  function PriceIdOrPlanIdMissing() {
    var _this10;

    _classCallCheck(this, PriceIdOrPlanIdMissing);

    for (var _len10 = arguments.length, params = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      params[_key10] = arguments[_key10];
    }

    _this10 = _super10.call.apply(_super10, [this].concat(params));
    _this10.name = 'PriceIdOrPlanIdMissing';
    _this10.message = 'Please provide a priceId or planId. You can create a product in the Stripe dashboard and find its priceId there.';
    _this10.status = statusCodes['Bad Request'];
    return _this10;
  }

  return PriceIdOrPlanIdMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SubscriptionPlanAlreadyPurchased = /*#__PURE__*/function (_Error11) {
  _inherits(SubscriptionPlanAlreadyPurchased, _Error11);

  var _super11 = _createSuper(SubscriptionPlanAlreadyPurchased);

  function SubscriptionPlanAlreadyPurchased() {
    var _this11;

    _classCallCheck(this, SubscriptionPlanAlreadyPurchased);

    for (var _len11 = arguments.length, params = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      params[_key11] = arguments[_key11];
    }

    _this11 = _super11.call.apply(_super11, [this].concat(params));
    _this11.name = 'SubscriptionPlanAlreadyPurchased';
    _this11.message = 'Subscription plan already purchased. Cancel subscription to purchase another.';
    _this11.status = statusCodes['Conflict'];
    return _this11;
  }

  return SubscriptionPlanAlreadyPurchased;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var StripeAccountNotConnected = /*#__PURE__*/function (_Error12) {
  _inherits(StripeAccountNotConnected, _Error12);

  var _super12 = _createSuper(StripeAccountNotConnected);

  function StripeAccountNotConnected() {
    var _this12;

    _classCallCheck(this, StripeAccountNotConnected);

    for (var _len12 = arguments.length, params = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      params[_key12] = arguments[_key12];
    }

    _this12 = _super12.call.apply(_super12, [this].concat(params));
    _this12.name = 'StripeAccountNotConnected';
    _this12.message = 'Stripe account not connected. Connect a Stripe account in the admin panel.';
    _this12.status = statusCodes['Forbidden'];
    return _this12;
  }

  return StripeAccountNotConnected;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SubscriptionNotFound = /*#__PURE__*/function (_Error13) {
  _inherits(SubscriptionNotFound, _Error13);

  var _super13 = _createSuper(SubscriptionNotFound);

  function SubscriptionNotFound() {
    var _this13;

    _classCallCheck(this, SubscriptionNotFound);

    for (var _len13 = arguments.length, params = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      params[_key13] = arguments[_key13];
    }

    _this13 = _super13.call.apply(_super13, [this].concat(params));
    _this13.name = 'SubscriptionNotFound';
    _this13.message = 'Subscription not found. User must purchase a subscription.';
    _this13.status = statusCodes['Payment Required'];
    return _this13;
  }

  return SubscriptionNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SubscriptionInactive = /*#__PURE__*/function (_Error14) {
  _inherits(SubscriptionInactive, _Error14);

  var _super14 = _createSuper(SubscriptionInactive);

  function SubscriptionInactive(subscriptionStatus) {
    var _this14;

    _classCallCheck(this, SubscriptionInactive);

    for (var _len14 = arguments.length, params = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
      params[_key14 - 1] = arguments[_key14];
    }

    _this14 = _super14.call.apply(_super14, [this].concat(params));
    _this14.name = 'SubscriptionInactive';
    _this14.message = "The user's subscription is inactive.";
    _this14.subscriptionStatus = subscriptionStatus;
    _this14.status = statusCodes['Payment Required'];
    return _this14;
  }

  return SubscriptionInactive;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SubscriptionNotPurchased = /*#__PURE__*/function (_Error15) {
  _inherits(SubscriptionNotPurchased, _Error15);

  var _super15 = _createSuper(SubscriptionNotPurchased);

  function SubscriptionNotPurchased() {
    var _this15;

    _classCallCheck(this, SubscriptionNotPurchased);

    for (var _len15 = arguments.length, params = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      params[_key15] = arguments[_key15];
    }

    _this15 = _super15.call.apply(_super15, [this].concat(params));
    _this15.name = 'SubscriptionNotPurchased';
    _this15.message = 'Subscription not purchased. User must purchase a subscription.';
    _this15.status = statusCodes['Payment Required'];
    return _this15;
  }

  return SubscriptionNotPurchased;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SubscriptionAlreadyCanceled = /*#__PURE__*/function (_Error16) {
  _inherits(SubscriptionAlreadyCanceled, _Error16);

  var _super16 = _createSuper(SubscriptionAlreadyCanceled);

  function SubscriptionAlreadyCanceled() {
    var _this16;

    _classCallCheck(this, SubscriptionAlreadyCanceled);

    for (var _len16 = arguments.length, params = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      params[_key16] = arguments[_key16];
    }

    _this16 = _super16.call.apply(_super16, [this].concat(params));
    _this16.name = 'SubscriptionAlreadyCanceled';
    _this16.message = 'Subscription already canceled. User must purchase a new subscription.';
    _this16.status = statusCodes['Bad Request'];
    return _this16;
  }

  return SubscriptionAlreadyCanceled;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TrialExpired = /*#__PURE__*/function (_Error17) {
  _inherits(TrialExpired, _Error17);

  var _super17 = _createSuper(TrialExpired);

  function TrialExpired() {
    var _this17;

    _classCallCheck(this, TrialExpired);

    for (var _len17 = arguments.length, params = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      params[_key17] = arguments[_key17];
    }

    _this17 = _super17.call.apply(_super17, [this].concat(params));
    _this17.name = 'TrialExpired';
    _this17.message = 'Trial expired. User must purchase a subscription.';
    _this17.status = statusCodes['Payment Required'];
    return _this17;
  }

  return TrialExpired;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var StripeError = /*#__PURE__*/function (_Error18) {
  _inherits(StripeError, _Error18);

  var _super18 = _createSuper(StripeError);

  function StripeError(error) {
    var _this18;

    _classCallCheck(this, StripeError);

    for (var _len18 = arguments.length, params = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
      params[_key18 - 1] = arguments[_key18];
    }

    _this18 = _super18.call.apply(_super18, [this, error].concat(params));
    var status = error.status,
        type = error.type,
        message = error.message;
    _this18.name = 'StripeError';
    _this18.message = message;
    _this18.type = type;
    _this18.status = status;
    return _this18;
  }

  return StripeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default {
  SuccessUrlMissing: SuccessUrlMissing,
  SuccessUrlMustBeString: SuccessUrlMustBeString,
  SuccessUrlInvalid: SuccessUrlInvalid,
  CancelUrlMissing: CancelUrlMissing,
  CancelUrlMustBeString: CancelUrlMustBeString,
  CancelUrlInvalid: CancelUrlInvalid,
  StripeJsLibraryMissing: StripeJsLibraryMissing,
  PaymentsDisabled: PaymentsDisabled,
  PriceIdOrPlanIdAllowed: PriceIdOrPlanIdAllowed,
  PriceIdOrPlanIdMissing: PriceIdOrPlanIdMissing,
  SubscriptionPlanAlreadyPurchased: SubscriptionPlanAlreadyPurchased,
  StripeAccountNotConnected: StripeAccountNotConnected,
  SubscriptionNotFound: SubscriptionNotFound,
  SubscriptionInactive: SubscriptionInactive,
  SubscriptionNotPurchased: SubscriptionNotPurchased,
  SubscriptionAlreadyCanceled: SubscriptionAlreadyCanceled,
  TrialExpired: TrialExpired,
  StripeError: StripeError
};